import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'

export const getActivityPartConstraintLifetime = (
  activityPart: FrontActivityPart<FrontActivityWithAggregate>,
): number | null => {
  if (!activityPart.activityConstraint) {
    return null
  }

  let minimalLifeTime = Infinity
  const now = Date.now()

  for (const date of [
    activityPart.activityConstraint.accessibleUntil,
    activityPart.activityConstraint.startFrom,
    activityPart.activityConstraint.startUntil,
    activityPart.activityConstraint.gracePeriodUntil,
    activityPart.activityConstraint.revealResultsFrom,
    activityPart.activityConstraint.due,
    activityPart.activityConstraint.resultsDisclosureFrom,
  ]) {
    if (!date) {
      continue
    }

    const lifeTime = new Date(date).getTime() - now

    if (lifeTime <= 0) {
      // if date in a past. treat it as we have fresh data from backend
      continue
    }

    minimalLifeTime = Math.min(minimalLifeTime, lifeTime)
  }

  return minimalLifeTime === Infinity ? null : minimalLifeTime
}
